const obj = {
  id: '',
  description: '',
  type: '', // whatsapp, whatsappOrganizer
  serverNumber: '',
  templateId: '',
  numberOfTags: 0,
  attributeTags: [],
  hasUrl: false,
  url: '',
  urlType: '', // "DOCUMENT", "VIDEO", "IMAGE"
  eventId: 0,
  scheduleId: 0,
  scheduleName: '',
  groupId: 0,
  groupName: '',
  organizerCellPhone: '',
  log: '',
}

export default function AdminActionModel(params = obj) {
  return {
    ...obj,
    ...params,
  };
}
